import { render, staticRenderFns } from "./Cannabis.vue?vue&type=template&id=634ba0c3&"
import script from "./Cannabis.vue?vue&type=script&lang=js&"
export * from "./Cannabis.vue?vue&type=script&lang=js&"
import style0 from "./Cannabis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports